export const enum WebEventTypes {
    VIEW_EVENT = "web_onboarding_screen_viewed",
    RESULT_EVENT = "web_onboarding_screen_result",
    SKIP_EVENT = "web_onboarding_screen_skipped",
    WEB_BUTTON_CLICK = "web_button_click",
    WEB_LINK_CLICK = "web_link_click",
    PURCHASE_STARTED = "web_purchase_started",
    PURCHASE_COMPLETED = "web_purchase_completed",
    PURCHASE_FAILED = "web_purchase_failed",
    ERROR_EVENT = "web_error",
    AB_TEST = "web_ab_test",
    PAYWALL_SCROLL = "web_onboarding_screen_scroll",
    PAYWALL_SHOWN = "web_paywall_shown",
    FORCE_LINK = "web_force_link",
    AGE_WARNING = "age_warning_message",
    FUNNEL_ENTRY = "web_funnel_entry",
    PAGE_REFRESH = "web_page_refresh",
}

export const enum WebEventProps {
    BUTTON_NAME = "button_name",
    SCREEN = "screen",
    RESULT = "result",
    TYPE = "type",
    PRICE = "price",
    METHOD = "method",
    PERCENTAGE = "percentage",
    PRODUCT_ID = "product_id",
    CURRENCY = "currency",
    LOAD_STATUS = "load_status",
    LOAD_ERROR = "load_error",
    AVAILABLE_CHECKLIST_OFFER_IDS = "available_checklist_offer_ids",
    AVAILABLE_CHECKLIST_OFFER_COUNT = "available_checklist_offer_count",
    CHECKLIST_ITEM_ID = "checklist_item_id",
    PSG_EMAIL_SCREEN = "psg_email_screen",
}

export type EventPropsType = { [key in WebEventProps]?: string | number | null | boolean };

export const enum EventScreenTypes {
    ACTION_PLAN_SPEED = "action_plan_speed",
    PRIMARY_GOAL = "primary_goal",
    BIGGEST_DRIVE = "biggest_drive",
    EMAIL = "email",
    EMAIL_CONSENT = "email_consent",
    SHARE_VIDEO = "share_video",
    FIRST_LOADER = "first_loader",
    BOTH_FIRST_LOADER = "both_first_loader",
    PROMO_PAYWALL = "promo_paywall",
    PROMO_PAYWALL_BODY_SCAN = "promo_paywall_body_scan",
    PAYWALL = "paywall",
    CIRCULAR_LOADER = "circular_loader",
    FIRST_SCREEN_AGE_GROUP = "first_screen_age_group",
    SOCIAL_PROOF = "social_proof",
    AI_WEIGHT_PREDICT = "ai_weight_prediction",
    NAME = "name",
    UPSELL = "upsell",
    UPSELL_DISCOUNT = "upsell_discount",
    UPSELL_CONGRATS = "upsell_congrats",
    UPSELL_CHECKLIST = "upsell_checklist",
    UPSELLS_CHECKLIST = "upsells_checklist",
    NUTRITION_BOOK = "nutrition book",
    DISCOUNT_POPUP = "popup with discount",
    WHATSAPP_CONNECT = "whatsapp_connect",
    WHATSAPP_NUMBER_CONFIRMATION = "whatsapp_number_confirmation",
    WHATSAPP_CONNECT_SUCCESS = "whatsapp_connect_success",
    SUPPLEMENTS_GUIDE = "supplements_guide",
    ADD_ONS_DISCLAIMER = "fakedoor_upsell_disclaimer",
    GIFT_ON_EMAIL_SCREEN = "gift_on_email_screen",
    BUNDLE_NUTRITION_SUPPLEMENTS = "bundle_nutrition_supplements",
    GENDER_SELECTION = "gender_selection",
    CHOOSE_TRAINING_JOURNEY = "choose_training_journey",
    PREDICTION_DATE_CHART = "prediction_date_chart",
    LES_MILLS_UPGRADE = "les_mills_upgrade",
    // Promocode Flow
    REDEEM_PROMO_CODE = "redeem_promo_code",
    PROMO_CODE_EMAIL = "promo_code_email",
    PROMO_CODE_PAYWALL = "promo_code_paywall",
    PROMOCODE_ERROR = "promo_code_error",
    WINBACK_POPUP = "winback_popup",

    // Nysc Flow
    NYSC_LANDING = "nysc_landing",
    NYSC_LANDING_EMAIL = "nysc_landing_email",
    NYSC_PAYWALL = "nysc_paywall",
    NYSC_FUNNEL_HOW_PLAN_WORKS = "nysc_funnel_how_plan_works",
    NYSC_FUNNEL_OFFER = "nysc_funnel_offer",

    // PSG Flow
    PSG_EMAIL_SCREEN = "psg_landing_email",
    PSG_PAYWALL = "psg_paywall",
    PSG_INVALID_OFFER = "psg_invalid_offer",

    // PSG June 26 Giveaway Flow
    PSG_JUNE_26_LANDING = "psg_june_26_giveaway_landing",
    PSG_JUNE_26_LANDING_EMAIL = "psg_june_26_giveaway_landing_email",
    PSG_JUNE_26_FUNNEL_INTRO = "psg_june_26_giveaway_funnel_intro",
    PSG_JUNE_26_FUNNEL_PROMO = "psg_june_26_giveaway_funnel_promo",
    PSG_JUNE_26_FUNNEL_WORKOUT = "psg_june_26_giveaway_funnel_workout",
    PSG_JUNE_26_FUNNEL_TRAINING = "psg_june_26_giveaway_funnel_training",
    PSG_JUNE_26_FUNNEL_AI_COACH = "psg_june_26_giveaway_funnel_ai_coach",
    PSG_JUNE_26_FUNNEL_EMAIL = "psg_june_26_giveaway_funnel_email",
    PSG_JUNE_26_PAYWALL = "psg_june_26_giveaway_paywall",
}

export const NYSC_FUNNEL_VIEW_EVENT_PREFIX = "nysc_funnel";

export const enum EventButtonTypes {
    BACK = "back",
    SUBMIT_EMAIL = "submit_email",
    SWIPE_AI_SLIDER = "swipe_ai_slider",
    SWIPE_INTRO_SLIDER = "swipe_intro_slider",
    SWIPE_REVIEWS_SLIDER = "swipe_reviews_slider",
    SWIPE_SLIDER = "swipe_slider",
    OPEN_PROFILE = "open_profile",
    CONNECT = "connect",
    NOT_NOW = "not_now",
    CONTINUE = "continue",
    VIEW_FULL_REPORT_EXAMPLE = "view_full_report_example",
    UNLOCK_REPORT = "unlock_report",
    OPEN_PAYMENT_POPUP = "open_payment_popup",
    CLOSE_PAYMENT_POPUP = "close_payment_popup",
    SWITCH_PAYMENT_METHOD = "switch_payment_method",
    CLOSE_WINBACK_POPUP = "close_winback_popup",
    NYSC_FUNNEL_YOUR_OFFER = "your_offer",
    NYSC_FUNNEL_HOW_IT_WORKS_TAB = "how_it_works",
}

export const enum EventResultTypes {
    ACCEPT = "accept",
    DECLINE = "decline",
    CLOSE = "close",
    CONTINUE = "continue",
    SKIP = "skip",
    BUY = "buy",
    PURCHASE = "purchase",
    ACTIVATE = "activate",
}

export const enum EventLinkTypes {
    privacyPolicy = "privacy_policy",
    refundPolicy = "refund_policy",
    termsOfUse = "terms_of_use",
    supportLink = "support_link",
    faq = "faq",
}

export const enum EventPaymentMethodTypes {
    APPLE_PAY = "applepay",
    CARD = "card",
    PAYPAL = "paypal",
    GOOGLE_PAY = "googlepay",
    VENMO = "venmo",
}

export enum EventLoadStatus {
    SUCCESS = "success",
    FAILED = "failed",
}
